/**
 * Otevření rezervačního okna odkudkoli z webu (horní lišta, patička, info stránky).
 *
 * Rezervační modal poslouchá událost `sobacov:open-reservation`, ale je
 * namontovaný jen na hlavní stránce. Z info stránky (#podminky, #info-cenik…)
 * se proto nejdřív přepne na hlavní stránku a událost se pošle, až modal
 * skutečně existuje.
 */
export type BookingDetail = { type: string; kind: 'stay' | 'hourly'; label: string; from_dt?: string; to_dt?: string; persons?: number }

export const BOOKING_TYPES: Record<string, BookingDetail> = {
  penzion:       { type: 'penzion',       kind: 'stay',   label: 'Pokoj penzionu' },
  chatka:        { type: 'chatka',        kind: 'stay',   label: 'Rybářská chatka' },
  glamping_tiny: { type: 'glamping_tiny', kind: 'stay',   label: 'Tiny house' },
  kemp:          { type: 'kemp',          kind: 'stay',   label: 'Bivak' },
  karavan:       { type: 'karavan',       kind: 'stay',   label: 'Karavan' },
  tenis:         { type: 'tenis',         kind: 'hourly', label: 'Tenisový kurt' },
  beach:         { type: 'beach',         kind: 'hourly', label: 'Beach volejbal' },
  sauna:         { type: 'sauna',         kind: 'hourly', label: 'Plovoucí sauna na molu' },
}

const SUBPAGE = /^#(podminky|info-|gdpr|pravidla|preplanovat|partner|checkin|preview-payment)/

/**
 * Penzion dočasně jen přes Booking.com (Robin 26. 10. 2026; za ~týden napojení iCal).
 * Řídí text slot `penzion_booking_url` v appce (Admin → Web): vyplněný = všechny cesty
 * k rezervaci pokoje vedou ven na Booking, prázdný = zpět naše online rezervace.
 * Než se obsah načte, platí výchozí odkaz (stejný jako default na serveru).
 */
export const PENZION_BOOKING_DEFAULT_URL = 'https://www.booking.com/hotel/cz/rodinny-penzion-sobacov.cs.html'
let penzionExternal: string | null = PENZION_BOOKING_DEFAULT_URL

export function penzionUrlFrom(content: Record<string, unknown>): string | null {
  const v = content['penzion_booking_url']
  if (v === undefined) return PENZION_BOOKING_DEFAULT_URL
  const s = String(v || '').trim()
  return s || null
}
export function setPenzionExternalFromContent(content: Record<string, unknown>) {
  penzionExternal = penzionUrlFrom(content)
}
export function getPenzionExternalUrl(): string | null {
  return penzionExternal
}

export function openBooking(detail: BookingDetail) {
  if (detail.type === 'penzion' && penzionExternal) {
    window.open(penzionExternal, '_blank', 'noopener')
    return
  }
  const fire = () => document.dispatchEvent(new CustomEvent('sobacov:open-reservation', { detail }))
  if (!SUBPAGE.test(window.location.hash)) { fire(); return }
  // na podstránce: nejdřív hlavní stránka, modal se namontuje po přepnutí routy
  window.location.hash = '#rezervace'
  let tries = 0
  const tick = () => {
    tries += 1
    if (document.getElementById('rezervace')) { fire(); return }
    if (tries < 20) setTimeout(tick, 100)
  }
  setTimeout(tick, 100)
}
